<template>
  <circle cx="1.75507" cy="2.25507" r="1.50507" fill="#3769D6" />
  <circle cx="1.75507" cy="9.55731" r="1.50507" fill="#3769D6" />
  <circle cx="6.9953" cy="3.25849" r="1.50507" fill="#3769D6" />
  <path d="M1.72656 2.0874V10.0308" stroke="#3769D6" stroke-width="0.836149" />
  <path
    d="M1.78288 10.3107C1.59707 9.01003 1.89436 6.54803 3.78964 6.54803C6.46531 6.54803 6.99488 5.5725 6.99488 3.34277"
    stroke="#3769D6"
    stroke-width="0.836149"
  />
</template>
